import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { IsInt } from 'class-validator';
import { PromotionExposeGroup } from '../interface';
export class PutPromocodeTemplateUsageRulesDto {
}
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PutPromocodeTemplateUsageRulesDto.prototype, "quotaPerUser", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsInt({ always: true }),
    __metadata("design:type", Number)
], PutPromocodeTemplateUsageRulesDto.prototype, "quotaPerCode", void 0);
//# sourceMappingURL=PutPromocodeTemplateUsageRulesDto.js.map